// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+ihpa","copyright":"Footer_copyright__2WB24"};